import React from 'react';
import { ResponsivePie } from '@nivo/pie';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowTrendDown, faArrowTrendUp, faArrowsLeftRight, faMoneyBillTransfer } from "@fortawesome/free-solid-svg-icons";
import '../OverviewOrg.css'

const TotalRevenue = ({income}) => {

  var colors = ['#a7a8a0', '#a7a8a0'] 

  const difference = income.totalRevenueToday - income.totalRevenueYesterday;

  let data;
  if (difference < 0) {
    data = [
      { id: 'Yesterday', value: income.totalRevenueYesterday - income.totalRevenueToday },
      { id: 'Today', value: income.totalRevenueToday },
    ];
  } else {
    data = [
      { id: 'Yesterday', value: income.totalRevenueToday -income.totalRevenueYesterday   },
      { id: 'Today', value: income.totalRevenueYesterday },
    ];
  }


  
  if(income.revenuePercentage >= 100 || income.totalRevenueYesterday < income.totalRevenueToday ) {

    data = [
      { id: 'Yesterday', value: 100 },
      { id: 'Today', value: 0 },
    ];
  }


  if (difference === 0) {
    data = [
      { id: 'Yesterday', value: 100 },
      { id: 'Today', value: 0 },
    ];
  } 


  return (
    <div className='small-stat-box' style={{display:"flex", justifyContent:"space-around"}}>
         <div style={{width:"30%",marginTop:"1em"}}>
            <FontAwesomeIcon style={{width:"20%"}} icon={faMoneyBillTransfer} />
            <h3>£{income.totalIncome}</h3>
            <h5>All Time Revenue Generated</h5>
            </div>
         
         <div>
            
         </div>

      <div style={{ height: "10vh", width: "30%", marginTop: "1em" }}>
        <div class="pie-chart" style={{backgroundColor:"#61cdbb"}}>
          <div class="inner-circle">
            {income.revenuePercentage > 0 ? (
              <FontAwesomeIcon
                icon={faArrowTrendUp}
                style={{ color: "#26c030" }}
              />
            ) : (
              <FontAwesomeIcon icon={faArrowsLeftRight} size='lg' style={{color: "#f4da2f",}} />
            )}
          </div>
        </div>
        <h5 className="percentage">{income.revenuePercentage > 0 ? income.revenuePercentage + "%" : ''}</h5>
      </div>
     
    </div>
     
  );
};

export default TotalRevenue;
